<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
        <i class="fal fa-times-circle fa-lg"></i>
      </span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a
            class="nav-link m-tabs__link active"
            data-toggle="tab"
            href="#save_customer"
            role="tab"
          >
            <h6><span class="far fa-users"></span> Grupo</h6>
          </a>
        </li>
        <li class="nav-item m-tabs__item" v-if="customerGroupId > 0">
          <a
            class="nav-link m-tabs__link"
            data-toggle="tab"
            href="#customer_group_history"
            role="tab"
          >
            <h6><span class="far fa-history"></span> Histórico</h6>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="save_customer" role="tabpanel">
          <CustomerGroupsSaveForm />
        </div>

        <div class="tab-pane" id="customer_group_history" role="tabpanel">
          <CustomerGroupHistory />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerGroupsSaveForm from '@/components/customers/groups/CustomerGroupsSaveForm';
import CustomerGroupHistory from '@/components/customers/groups/CustomerGroupHistory';

export default {
  name: 'CustomerGroupsModal',
  components: {
    CustomerGroupsSaveForm,
    CustomerGroupHistory,
  },
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showCustomerGroupSave = null;
    },
  },
  computed: {
    customerGroupId() {
      return this.$store.state.showCustomerGroupSave;
    },
  },
};
</script>
<style>
.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
